export default "__VITE_ASSET__CzKIWAtg__"